import HeaderLeft from '../../../components/Header/HeaderLeft'

export default function HealthSectionHeaderAge() {
  
  return (
<>

    <HeaderLeft
        
      headerleft = {'Your Biological Age'}

    />
      
   

</>
   )
}